import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { bonuses, BONUS_VALUE } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-y border-line bg-canvasAlt" data-id="element-19" data-mp="vsw8y0tmyjd2">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-20" data-mp="qu2y6g5qh6gl">
        <Reveal className="flex flex-col items-center gap-3" data-id="element-21" data-mp="qw5wrokyc7wx">
          <div data-id="element-22" data-mp="14rzwbgzu5kxd">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-blush" data-id="element-23" data-mp="14rrfje0ldvgw">
              Incluidos hoy
            </p>
            <h2 id="bonos" className="mt-2 font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-24" data-mp="1ejdzbyqzx2v9">
              6 Bonos estratégicos
            </h2>
          </div>
          <p className="rounded-full border border-gold/40 bg-gold-soft px-5 py-2 text-sm font-bold uppercase tracking-wide text-gold" data-id="element-25" data-mp="1njkd7lqlw4uy">
            Valor total {BONUS_VALUE} → incluidos hoy
          </p>
        </Reveal>

        <ul className="mt-8 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="3prddy7vc8xw1">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-6 text-center" data-id="element-27" data-mp="3tsffwwgn3o1p" data-mpi={i}>
              <span className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.2em] text-blush" data-id="element-28" data-mp="7icltqfoba6g">
                <GiftIcon size={13} data-id="element-29" data-mp="gl5dhusrpnwt" />
                Bono {i + 1}
              </span>
              <h3 className="mt-2 font-display text-lg font-bold uppercase leading-tight text-ink" data-id="element-30" data-mp="lc3tet9ugjzj">
                {bono.title}
              </h3>
              <p className="mt-2 mb-5 text-sm leading-relaxed text-ink-muted" data-id="element-31" data-mp="q9vlbnaho63q">
                {bono.desc}
              </p>
              <div className="mt-auto flex w-full items-center justify-between gap-3 border-t border-line pt-4" data-id="element-32" data-mp="vc4dwijg965b">
                <span className="text-sm text-ink-subtle line-through" data-id="element-33" data-mp="107091rjzg9mn">
                  Valor {bono.value}
                </span>
                <span className="text-sm font-bold uppercase tracking-wide text-success" data-id="element-34" data-mp="5mnvrojlqo20">
                  Incluido
                </span>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}